<template>
    <div>
        <a-modal :closable="false"
			wrap-class-name="full-modal"
			width="100%"
            :visible="isVisible"
			:dialog-style="{ top: '10px' }"
        >
            <template #footer>
				<a-button @click="handleBtnCancel">
					Cancel
				</a-button>

                <a-button @click="handleBtnBack" v-show="step==1">
					Back
				</a-button>

                <a-button @click="handleBtnNext" v-show="step==0" :disabled="menu.menuItems.length<=0">
					Next
				</a-button>

				<a-button type="primary" @click="handleBtnSave" v-show="step==1">
					Create
				</a-button>

			</template>

            <a-row type="flex" :gutter="24" v-show="step==0">

                <!-- Items not in menu -->
                <a-col :span="12" :lg="12" class="mb-24">
					<a-card :bordered="false" 
                            class="header-solid h-full demo-infinite-container" 
                            :bodyStyle="{paddingTop: 0 }"
                            :span="18" :lg="18" 
                            v-infinite-scroll="handleInfiniteOnload"
                            :infinite-scroll-disabled="busy"
                    >
						<template #title>
							 <!-- List header -->
                            <a-row type="flex" :gutter="24">

                                <a-col :span="12" class="mb-24">
                                    <h5 class="mb-0">Repository</h5>
                                </a-col>

                                <a-col :span="12" class="mb-24 text-right">
                                    <a-button @click="setAllMenu" class="ml-15">
                                        <i class="ni ni-archive-2 mr-5"></i> SET ALL
                                    </a-button>
                                </a-col>

                            </a-row>
                            <!-- / List header -->
						</template>

                        <a-collapse accordion>
                            <template v-for="(category, index) in categoriesInRepository">
                                <a-collapse-panel :key="index" 
                                                  :header="category.categoryName"
                                                  v-show="getItemsNotInMenuByCategory(category.categoryName).length>0"
                                >
                                    <a-table
                                        :data-source="getItemsNotInMenuByCategory(category.categoryName)"
                                        :columns="columns"
                                        :pagination="false"
                                        rowKey="itemId" 
                                    >
                                        <template slot="index" slot-scope="text, record, index">
                                            <p>{{ index + 1 }}</p>
                                        </template>

                                        <template slot="actions" slot-scope="record">
                                            <a-button-group>
                                                <a-button type="link" @click="handleBtnAddToMenu(record)">
                                                    Add
                                                </a-button>   
                                            </a-button-group>
                                        </template>

                                    </a-table>
                                </a-collapse-panel>
                            </template>
                        </a-collapse>	
					</a-card>		
				</a-col>
                <!-- / Items not in menu -->

                <!-- Menu Items -->
                <a-col :span="12" :lg="12" class="mb-24">
                    <a-card :bordered="false" 
                            class="header-solid h-full mb-24 demo-infinite-container" 
                            :bodyStyle="{paddingTop: 0, paddingBottom: '20px' }"
                            :span="18" :lg="18" v-infinite-scroll="handleInfiniteOnload"
                            :infinite-scroll-disabled="busy"
                    >
                        <template #title>
                            <h5 class="mb-0">Menu</h5>
                        </template>
                        <a-collapse accordion>
                            <template v-for="(category, index) in menu.menuCategories">
                                <a-collapse-panel :key="index" :header="category.categoryName">
                                    <a-table
                                        :data-source="getMenuItemsByCategories(category.categoryName)"
                                        :columns="columns"
                                        :pagination="false"
                                        rowKey="itemId" 
                                    >
                                        <template slot="index" slot-scope="text, record, index">
                                            <p>{{ index + 1 }}</p>
                                        </template>

                                        <template slot="actions" slot-scope="record">
                                            <a-button-group>
                                                <a-button type="link" @click="handleBtnRemoveFromMenu(record)">
                                                    Remove
                                                </a-button>
                                            </a-button-group>
                                        </template>

                                    </a-table>
                                </a-collapse-panel>
                            </template>
                        </a-collapse>
                    </a-card>
                </a-col>
                <!-- / Menu Items -->
            </a-row>

            <a-row v-show="step==1">
                <a-card :bordered="false" class="header-solid" :bodyStyle="{paddingTop: 0 }" :headStyle="{paddingBottom: '0' }">
                <h6>Menu Information</h6> 
                    <a-form-model :model="menu"
                                    :rules="menuRules"
                                    ref="menuForm"
                    >  
                        <a-row :gutter="[24]">
                            <a-col :span="6">
                                <a-form-model-item class="mb-10"
                                        label="Menu Name"
                                        ref="menuName"
                                        prop="menuName"
                                >
                                    <a-input v-model="menu.menuName"
                                            @blur="() => { $refs.menuName.onFieldBlur() }"
                                    />
			                    </a-form-model-item>
                            </a-col>

                            <a-col :span="18">
                                <a-form-model-item class="mb-10">
                                    <a-checkbox v-model="menu.monday">
                                        Mon
                                    </a-checkbox>
                                    <a-checkbox v-model="menu.tuesday">
                                        Tue
                                    </a-checkbox>
                                    <a-checkbox v-model="menu.wednesday">
                                        Wed
                                    </a-checkbox>
                                    <a-checkbox v-model="menu.thursday">
                                        Thu
                                    </a-checkbox>
                                    <a-checkbox v-model="menu.friday">
                                        Fri
                                    </a-checkbox>
                                    <a-checkbox v-model="menu.saturday">
                                        Sat
                                    </a-checkbox>
                                    <a-checkbox v-model="menu.sunday">
                                        Sun
                                    </a-checkbox>
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                        <a-row :gutter="[24]">
                            <a-col :span="6">
                                <a-form-model-item class="mb-10"
                                    label="Description"
                                >
                                    <a-textarea placeholder="For example: Second menu or Special menu" :rows="3" v-model="menu.description"/>
			                    </a-form-model-item>
                            </a-col>
                            <a-col :span="6">
                                <a-form-model-item class="mb-10"
                                    label="From time"
                                    ref="fromTime"
                                    prop="fromTime"
                                >
                                    <a-time-picker format="HH:mm"
                                            :minuteStep="5"
                                            inputReadonly
                                            hideDisabledOptions
                                            v-model="menu.fromTime"
                                            @change="() => { $refs.fromTime.onFieldBlur() }"
                                    />
			                    </a-form-model-item>  
                            </a-col>
                            <a-col>
                                <a-form-model-item class="mb-10"
                                    label="To time"
                                    ref="toTime"
                                    prop="toTime"
                                >
                                    <a-time-picker format="HH:mm"
                                            :minuteStep="5"
                                            inputReadonly
                                            hideDisabledOptions
                                            v-model="menu.toTime"
                                            @change="() => { $refs.toTime.onFieldBlur() }"
                                    />
			                    </a-form-model-item>
                            </a-col>
                        </a-row>     
                    </a-form-model>
                </a-card>                        
            </a-row>
        </a-modal>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import InfiniteScroll from 'v-infinite-scroll'
import MenuItemCard from '../../../components/cards/MenuItemCard.vue'
import moment from 'moment'

export default {

    directives: { 
        InfiniteScroll 
    },

    inject : ['eventBus'],

    components : {
        MenuItemCard
    },

    computed : {
        ...mapState({
           
        }),
        ...mapGetters({
            categoriesInRepository : 'menus/categoriesInRepository'
        }),
        
    },
    data () {

        let checkFromTimeAndToTime = (rule, value, callback) => {
            if (this.menu.fromTime.isBefore(this.menu.toTime)) {
                callback( new Error('From time cannot be before to time!'));
            }
            else {
                callback();
            }
        };

        return {

            menuRules : {
                menuName : [
                    {
						required : true,
						message : 'The field cannot be empty',
						trigger: 'blur'
					},
					{
						min: 3,
						message : 'The field should have at least 3 characters',
						trigger: 'blur'
					}
                ]
            },

            columns : [
                {
					title: '#', dataIndex: 'index', scopedSlots: { customRender: 'index' },
				},
                {
					title: 'ITEM', dataIndex: 'itemName',
				},
                {
			        title : 'ACTION', scopedSlots : { customRender: 'actions'}, fixed: 'right'
		        }
            ],
            //
            //config data
            //
            isVisible : false,
            busy: false,
            step : 0,
			
            //
            //menu data
            //
            menu : {
                menuId : '',
                menuItems : [],
                menuCategories : [],
                menuName : '',
                description : '',
                fromTime : moment('00:00:00', 'HH:mm:ss'),
                toTime : moment('00:00:00', 'HH:mm:ss'),
                monday : true,
                tuesday : true,
                wednesday : true,
                thursday : true,
                friday : true,
                saturday : true,
                sunday : true
            },
            
            itemsNotInMenu : []
        }
    },

    methods : {
       
        showModal() {

            //
            //menu items not in menu
            //
            this.$store.getters['menus/itemsNotInMenuById'](null).forEach(i => {
                let item = {
                    itemId : i.itemId,
                    itemName : i.itemName,
                    categoryId : i.categoryId,
                    categoryName : i.category,
                    description : i.description,
                    imageUrl : i.imageUrl,
                    itemPrice : i.originalPrice,
                    tax : i.taxValue
                }
                this.itemsNotInMenu.push(item)
            });

            this.isVisible = true;
        },

        handleBtnSave() {

            this.$refs.menuForm.validate(async valid => {

                if (valid) {
                    await this.$store.dispatch('menus/createMenuAction', this.menu);
                    this.isVisible = false;
                }
            });
        },

        handleBtnCancel() {
            this.isVisible = false;
        },

        handleBtnBack() {
            this.step = 0;
        },

        handleBtnNext() {
            this.step = 1;
        },

        handleInfiniteOnload() {

        },

        handleBtnAddToMenu(record) {
   
            this.menu.menuItems.push(record);

            let index = this.itemsNotInMenu.findIndex(i => i.itemId === record.itemId);
            if (index > -1) {
                this.itemsNotInMenu.splice(index,1);
            }

            let category = this.menu.menuCategories.find(o => o.categoryId === record.categoryId);
            
            if(category == null) {

                category = {
                    categoryId : record.categoryId,
                    categoryName : record.categoryName
                }
                this.menu.menuCategories.push(category);
            }

        },

        handleBtnRemoveFromMenu(record) {
            this.itemsNotInMenu.push(record);
            let index = this.menu.menuItems.findIndex(i => i.itemId === record.itemId); 
            if (index > -1) {
                this.menu.menuItems.splice(index,1);
            }
            let items = this.getMenuItemsByCategories(record.category);

            if (items.length <= 0) {
                console.log('items.length <= 0')
                let index = this.menu.menuCategories.findIndex(i => i.categoryId === record.categoryId); 
                if (index > -1) {
                    this.menu.menuItems.splice(index,1);
                }
            }
        },

        getMenuItemsByCategories(categoryName) {
            
            let items = [];
            this.menu.menuItems.forEach(m => {

                if (m.categoryName === categoryName) {
                    items.push(m);
                }
            });

            return items;
        },

        getItemsNotInMenuByCategory(categoryName) {

            let items = [];

            this.itemsNotInMenu.forEach(m => {

                if (m.categoryName === categoryName) {
                    items.push(m);
                }
            });
           
            return items;
        },

        setAllMenu() {

        }
    },

    created () {

    }
}

</script>

<style lang="scss">
	.full-modal {
  		.ant-modal {
    		max-width: 100%;
    		top: 0;
    		padding-bottom: 50;
    		margin: 0;
  		}
  		.ant-modal-content {
    		display: flex;
    		flex-direction: column;
    		height: calc(100vh);
  		}
  		.ant-modal-body {
    		flex: 1;
  		}
	}

    .demo-infinite-container {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        overflow: auto;
        padding: 8px 24px;
        height: 500px;
        width : 100%;
    }
    .demo-loading-container {
        position: absolute;
        bottom: 40px;
        width: 100%;
        text-align: center;
    }
</style>